<template>
    <div class="checkout__wrapper">
        <div class="row">
            <div class="col-12 col-lg-4">
                <div class="registry-form-container bg-white">
                    <div class="checkout__stepnum">
                        1
                    </div>
                    <div class="text-center w-100">
                        <h4 class="checkout__column-title">
                            {{ $translate("OD3dprimaV2::Template.checkoutInvoiceAddress") }}
                        </h4>
                    </div>
                    <template v-if="addressListOverridden">
                        <slot name="override-address-lists"></slot>
                    </template>
                    <template v-else>
                        <div class="checkout__address">
                            <slot name="invoice-address-select"></slot>
                        </div>
<!--                        <h4 class="checkout__column-sub-title">-->
<!--                            {{ $translate("Ceres::Template.checkoutShippingAddress") }}-->
<!--                        </h4>-->
                        <div class="checkout__address">
                            <slot name="shipping-address-select"></slot>
                        </div>
                    </template>
                    <template>
                        <div class="checkout__wish">
                            <header>
                                <h3 class="checkout__your-address">{{ $translate("Ceres::Template.checkoutContactWish") }}</h3>
                            </header>
                            <contact-wish-input class="pb-3"></contact-wish-input>
                        </div>
                    </template>
                    <template>
                        <div class="checkout__sign">
                            <header>
                                <h3 class="checkout__your-address">{{ $translate("Ceres::Template.checkoutCustomerSign") }}</h3>
                            </header>
                            <customer-sign-input></customer-sign-input>
                        </div>
                    </template>
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <div class="bg-white">
                    <div class="checkout__stepnum">
                        2
                    </div>
                    <div class="text-center w-100">
                        <h4 class="checkout__column-title">
                            {{ $translate("OD3dprimaV2::Template.checkoutPaymentShipping") }}
                        </h4>
                    </div>
                    <div class="checkout__column-sub-title">
                        {{ $translate("Ceres::Template.checkoutPaymentMethod") }}
                    </div>
                    <div class="checkout__payment">
                        <slot name="payment-provider-select"></slot>
                    </div>
                    <div class="checkout__column-sub-title">
                        {{ $translate("Ceres::Template.checkoutShippingProfile") }}
                    </div>
                    <div class="checkout__shipping">
                        <slot name="shipping-profile-select"></slot>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <div class="bg-white">
                    <div class="checkout__stepnum">
                        3
                    </div>
                    <div class="text-center w-100">
                        <h4 class="checkout__column-title">
                            {{ $translate("OD3dprimaV2::Template.checkoutBasket") }}
                        </h4>
                    </div>
                    <div class="sidebar">
                        <div class="cmp cmp-checkout-sidebar">
                            <div class="cmp cmp-basket-preview-list">
                                <slot name="basket-list"></slot>
                            </div>
<!--                            <hr>-->
<!--                            <coupon></coupon>-->
<!--                            <hr class="mb-0">-->
                        </div>
                    </div>
                    <div class="sidebar">
                        <div class="cmp cmp-checkout-sidebar">
                            <slot name="totals"></slot>
                        </div>
                    </div>

<!--                    <div class="checkout__column-sub-title">-->
<!--                        {{ $translate("Ceres::Template.checkoutContactWish") }}-->
<!--                    </div>-->

<!--                    <contact-wish-input></contact-wish-input>-->
                    <div class="checkout__shipping-check">
                        <shipping-privacy-hint-check></shipping-privacy-hint-check>
                    </div>
                    <div class="checkout__privacy">
                        <accept-gtc-check></accept-gtc-check>
                    </div>

                    <slot name="opt-ins"></slot>
                    <slot name="place-order" :showModal="showModal"></slot>

                    <a v-if="initialCheckout.readOnly"
                       class="btn btn-block btn-outline-primary mt-3"
                       :href="urls.checkout+'?readonlyCheckout=0'">
                        <i class="fa fa-times" aria-hidden="true"></i>
                        {{ $translate("Ceres::Template.checkoutCancelCheckout") }}
                    </a>
                </div>
            </div>
        </div>
        <div class="modal fade" ref="checkoutModal" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-body" ref="checkoutModalContent"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const ApiService = require("ceres/app/services/ApiService");
const NotificationService = require("ceres/app/services/NotificationService");
const _isEqual = require("lodash/isEqual");

import TranslationService from "ceres/app/services/TranslationService";
import { removeUrlParam } from "ceres/app/services/UrlService";
import { mapState } from "vuex";

export default
{
    props:
    {
        template:
        {
            type: String,
            default: "#vue-checkout"
        },
        initialCheckout:
        {
            type: Object,
            required: true
        },
        deliveryAddressList:
        {
            type: Array,
            default: () => []
        },
        selectedDeliveryAddress:
        {
            type: Number,
            default: -99
        },
        billingAddressList:
        {
            type: Array,
            default: () => []
        },
        selectedBillingAddress:
        {
            type: Number,
            default: 0
        }
    },

    data()
    {
        return {
            urls: App.urls
        }
    },

    computed:
    {
        ...mapState({
            checkout: state => state.checkout,
            deliveryAddressId: state => state.address.deliveryAddressId
        }),
        addressListOverridden()
        {
            return !!this.$slots['override-address-lists'];
        }
    },

    created()
    {
        this.$store.dispatch("setCheckout", this.initialCheckout);
        this.$store.dispatch("initBillingAddress", { id: this.selectedBillingAddress, addressList: this.billingAddressList });
        this.$store.dispatch("initDeliveryAddress", { id: this.selectedDeliveryAddress, addressList: this.deliveryAddressList });

        this.addEventHandler();

        removeUrlParam("readonlyCheckout");
    },

    methods:
    {
        addEventHandler()
        {
            ApiService.listen("CheckoutChanged",
                checkout =>
                {
                    this.handleCheckoutChangedEvent(checkout.checkout);
                });

            document.addEventListener("afterPaymentMethodChanged", event =>
            {
                const newMethodOfPaymentId = event.detail;

                if (newMethodOfPaymentId !== this.checkout.payment.methodOfPaymentId)
                {
                    this.updateCheckoutAndBasket();
                }
            });
        },

        updateCheckoutAndBasket()
        {
            this.$store.commit("setIsBasketLoading", true);

            const reloadBasketPromise = this.$store.dispatch("refreshBasket");
            const reloadCheckoutPromise = this.$store.dispatch("refreshCheckout");

            Promise.all([reloadBasketPromise, reloadCheckoutPromise])
                .then(data =>
                {
                    this.$store.commit("setIsBasketLoading", false);
                });
        },

        handleCheckoutChangedEvent(checkout)
        {
            if (!this.isEquals(this.checkout.payment.methodOfPaymentList, checkout.paymentDataList, "id"))
            {
                NotificationService.info(
                    TranslationService.translate("Ceres::Template.checkoutMethodOfPaymentListChanged")
                );
                this.$store.commit("setMethodOfPaymentList", checkout.paymentDataList);
            }

            if (this.hasShippingProfileListChanged(this.checkout.shipping.shippingProfileList, checkout.shippingProfileList.slice()))
            {
                this.$store.commit("setShippingProfileList", checkout.shippingProfileList);
            }

            if (this.checkout.payment.methodOfPaymentId !== checkout.methodOfPaymentId)
            {
                NotificationService.warn(
                    TranslationService.translate("Ceres::Template.checkoutMethodOfPaymentChanged")
                );
                this.$store.commit("setMethodOfPayment", checkout.methodOfPaymentId);
            }

            if (this.checkout.shipping.shippingProfileId !== checkout.shippingProfileId)
            {
                NotificationService.warn(
                    TranslationService.translate("Ceres::Template.checkoutShippingProfileChanged")
                );
                this.$store.commit("setShippingProfile", checkout.shippingProfileId);
            }

            if (this.checkout.shipping.shippingCountryId !== checkout.shippingCountryId)
            {
                this.$store.commit("setShippingCountryId", checkout.shippingCountryId);
            }

            const responseDeliveryAddressId = checkout.deliveryAddressId !== 0 ? checkout.deliveryAddressId : -99;

            if (this.deliveryAddressId !== responseDeliveryAddressId)
            {
                NotificationService.warn(
                    TranslationService.translate("Ceres::Template.addressChangedWarning")
                );
                this.$store.commit("selectDeliveryAddressById", responseDeliveryAddressId);
            }

            if (!_isEqual(this.checkout.shipping.maxDeliveryDays, checkout.maxDeliveryDays))
            {
                this.$store.commit("setMaxDeliveryDays", checkout.maxDeliveryDays);
            }

            if (this.checkout.readOnly !== checkout.readOnly)
            {
                this.$store.commit("setIsCheckoutReadonly", checkout.readOnly);

                window.location.href = App.urls.checkout;
            }
        },

        hasShippingProfileListChanged(oldList, newList)
        {
            if (oldList.length !== newList.length)
            {
                NotificationService.info(
                    TranslationService.translate("Ceres::Template.checkoutShippingProfileListChanged")
                );
                return true;
            }

            this.sortList(oldList, "parcelServicePresetId");
            this.sortList(newList, "parcelServicePresetId");

            for (const index in oldList)
            {
                if(oldList.hasOwnProperty(index))
                {
                    if (oldList[index].parcelServicePresetId !== newList[index].parcelServicePresetId)
                    {
                        NotificationService.info(
                            TranslationService.translate("Ceres::Template.checkoutShippingProfileListChanged")
                        );
                        return true;
                    }
                    else if (oldList[index].shippingAmount !== newList[index].shippingAmount)
                    {
                        NotificationService.info(
                            TranslationService.translate("Ceres::Template.checkoutShippingProfilePriceChanged")
                        );
                        return true;
                    }
                    else if (oldList[index].shippingPrivacyInformation !== newList[index].shippingPrivacyInformation)
                    {
                        return true;
                    }
                }
            }

            return false;
        },

        isEquals(oldList, newList, fieldToCompare)
        {
            if (oldList.length !== newList.length)
            {
                return false;
            }

            for (const oldListItem of oldList)
            {
                if (newList.findIndex(newListItem => newListItem[fieldToCompare] === oldListItem[fieldToCompare]) === -1)
                {
                    return false;
                }
            }

            return true;
        },

        sortList(list, field)
        {
            list.sort((valueA, valueB) =>
            {
                if (valueA[field] > valueB[field])
                {
                    return 1;
                }

                if (valueA[field] < valueB[field])
                {
                    return -1;
                }

                return 0;
            });
        },

        showModal(content)
        {
            $(this.$refs.checkoutModalContent).html(content);
            $(this.$refs.checkoutModal).modal("show");
        }
    }
};
</script>
